const getFoldersToCreate = (initialFolders, currentFolders) => {
  const initialFolderIdsSet = new Set(initialFolders.map((f) => f.id));
  return currentFolders.filter((folder) => !initialFolderIdsSet.has(folder.id));
};

export default getFoldersToCreate;
